(() => {
  const order = ['XS','S','M','L','XL','XXL','3XL','4XL','5XL','6XL'];
  const normalize = (text) => {
    const value = text.split(' · ')[0].trim();
    return ({'2XL':'XXL','XXXL':'3XL','XXXXL':'4XL','4 Extra large':'4XL'})[value] || value;
  };
  function enhance(root = document) {
    root.querySelectorAll('.product-select[name="id"], .outfit-variant').forEach(select => {
      if (select.dataset.sizeButtons) return;
      const label = select.closest('label');
      if (!label) return;
      const group = document.createElement('div');
      group.className = 'cero-size-buttons';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', Array.from(label.childNodes).filter(n => n.nodeType === 3).map(n => n.textContent).join('').trim());
      const options = Array.from(select.options);
      (select.dataset.sizeCurve || '').trim().split('|').filter(Boolean).forEach(size => {
        if (!options.some(option => normalize(option.text) === size)) options.push({text:size,value:'',disabled:true});
      });
      options.sort((a,b) => {
        const x = normalize(a.text), y = normalize(b.text);
        const i = order.indexOf(x), j = order.indexOf(y);
        return (i < 0 ? 100 : i) - (j < 0 ? 100 : j) || x.localeCompare(y, undefined, {numeric:true});
      });
      options.forEach(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cero-size-button';
        button.textContent = normalize(option.text);
        button.dataset.variant = option.value;
        button.disabled = option.disabled;
        button.addEventListener('click', () => {
          select.value = option.value;
          select.dispatchEvent(new Event('change', {bubbles:true}));
        });
        group.append(button);
      });
      const sync = () => group.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variant === select.value && !button.disabled)));
      select.addEventListener('change', sync);
      label.after(group);
      select.dataset.sizeButtons = 'true';
      select.classList.add('cero-size-select--enhanced');
      if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) {
        const available = options.find(option => !option.disabled);
        if (available) { select.value = available.value; select.dispatchEvent(new Event('change', {bubbles:true})); }
      }
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
